import RadioOptionItem, { RadioOptionItemProps } from './RadioOptionItem';

export type { RadioOptionItemProps };
export default RadioOptionItem;
